import angular from 'angular';

/**
 * @typedef {import('./types').PopupScope} PopupScope
 */

angular.module('settings.popup').directive('settingsPopup', settingsPopup);

settingsPopup.$inject = ['$uibModal', '$mdDialog'];

/** @type {angular.IDirectiveFactory<PopupScope & angular.IScope>} */
function settingsPopup(
  $uibModal,
  /** @type {angular.material.IDialogService} */ $mdDialog,
) {
  var directive = {
    bindToController: true,
    link: link,
    restrict: 'A',
    scope: {
      titleText: '@title',
      onCancel: '&onCancel',
      onBack: '&onBack',
      onSubmit: '&onSubmit',
      tmplUrl: '@tmplUrl',
      object: '=object',
      data: '=data',
    },
  };
  return directive;

  function link(
    /** @type {PopupScope & angular.IScope} */ scope,
    element,
    attrs,
  ) {
    element.bind('click', function (event) {
      scope.model = angular.copy(scope.object);

      $mdDialog.show(
        // @ts-expect-error - alert actually supports arguments
        // but this feature is not covered with types
        $mdDialog.alert({
          clickOutsideToClose: true,
          targetEvent: event,
          parent: angular.element('body'),
          templateUrl: scope.tmplUrl
            ? scope.tmplUrl
            : new URL(
                'app/settings.popup/settings.popup.html?raw',
                import.meta.url,
              ),
          preserveScope: true,
          controller: 'settingsPopupCtrl',
          controllerAs: 'vm',
          scope,
        }),
      );
    });
  }
}
